







import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EnglishKeyboard from "./EnglishKeyboard.vue";
import DanishKeyboard from "./DanishKeyboard.vue";
import NumbersAndSignsKeyboard from "./NumbersAndSignsKeyboard.vue";
import { Style } from "@/services/styles/types";
import { WayfinderCSS } from "@/services/wayfinder/types";

@Component({
    components: {
        EnglishKeyboard,
        DanishKeyboard,
        NumbersAndSignsKeyboard
    }
})
export default class Keyboard extends Vue {
    @Prop() private value!: string;
    @Prop() private wayfinderCss!: WayfinderCSS;

    capital: boolean = false;
    showNumbers: boolean = false;
    showEnglish: boolean = false;

    write(char: string) {
        switch (char.toString().toLowerCase()) {
        case "capital":
            this.capital = !this.capital;
            return;
        case "remove": {
            this.$emit("input", this.value.slice(0, -1));
            return;
        }
        case "clear": {
            this.$emit("input", "");
            return;
        }
        case "space": {
            char = " ";
            this.$emit("input", this.value + char);
            return;
        }
        default: {
            char = this.capital ? char.toUpperCase() : char;
            this.$emit("input", this.value + char);
        }
        }
    }

    switchKeyboard(change: boolean) {
        this.showNumbers = change;
    }

    get styleModel() {
        return this.wayfinderCss ? this.wayfinderCss : {} as WayfinderCSS;
    }
}
